<div class="modal-main">
  <div class="close-modal">
    <button mat-icon-button (click)="onCancel()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="modal-header-container">
    <h3>Reject Event</h3>
  </div>

  <div style="min-height: 100%">
    <p
      style="
        margin-top: 20px;
        margin-bottom: 10px;
        text-align: center;
        font-size: 1.25em;
      "
    >
      Select a rejection code/description
    </p>
    <div mat-dialog-content [formGroup]="reasonForm" class="form-group">
      <mat-form-field class="dropdown-fix">
        <mat-label>Reason</mat-label>
        <mat-select formControlName="reasonCode">
          @for (
            reasonCodeDescription of reasonCodes;
            track reasonCodeDescription
          ) {
            <mat-option [value]="reasonCodeDescription.code">
              {{ reasonCodeDescription.code }} -
              {{ reasonCodeDescription.description }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (this.reasonForm.get("reasonCode")?.value === "O") {
        <mat-form-field>
          <mat-label>Description</mat-label>
          <input
            matInput
            formControlName="description"
            placeholder="Please specify"
          />
        </mat-form-field>
      }
    </div>
    <div
      mat-dialog-actions
      style="display: flex; justify-content: center; margin-bottom: 20px"
      [class.newsite]="data?.showNewDesign"
    >
      <button
        mat-flat-button
        color="primary"
        (click)="onConfirm()"
        [disabled]="!reasonForm.valid"
        [class.pill-confirm]="data?.showNewDesign"
      >
        Confirm
      </button>
      <button
        mat-stroked-button
        color="accent"
        (click)="onCancel()"
        [class.pill-cancel]="data?.showNewDesign"
      >
        Cancel
      </button>
    </div>
  </div>
</div>
